<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import {
  NXGDSButton,
  NXGDSButtonSizes,
  NXGDSButtonVariants,
  NXGDSModal
} from '@nsftx/seven-nxg-design-system'
import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'
import { redirectToSboLogin } from '@/utils/redirectToSboLogin'

const { cmsConfig } = storeToRefs(useCmsConfigStore())

const isServiceModeActive = computed({
  get: () => !!cmsConfig.value?.deviceSettings?.serviceMode,
  // Modal is non-dismissible; ignore close attempts from the design system.
  set: () => undefined
})
</script>

<template>
  <NXGDSModal
    v-model="isServiceModeActive"
    :show-close-button="false"
    :close-on-outside-click="false"
    :close-on-escape="false"
    width="480px"
    :title="$t('service_mode_modal_title')"
  >
    <p>{{ $t('service_mode_modal_description') }}</p>
    <template #footer>
      <NXGDSButton
        :variant="NXGDSButtonVariants.primary"
        :size="NXGDSButtonSizes.big"
        width="100%"
        @click="redirectToSboLogin"
      >
        {{ $t('service_mode_modal_operator_login_button') }}
      </NXGDSButton>
    </template>
  </NXGDSModal>
</template>
